<template>
  <div>
    <span style="font-weight: 600; margin-bottom: 10px; display: block">Bước 3: Kiểm tra dữ liệu</span>
    <div class="preview-table">
      <!-- Empty State -->
      <el-empty
          v-if="data.length === 0"
          description="Không có dữ liệu để hiển thị"
          :image-size="100"
      />

      <!-- Preview Table -->
      <el-table
          v-else
          :data="sortedData"
          max-height="400"
          border
          size="small"
          style="width: 100%"
      >
        <el-table-column
            align="center"
            v-for="(column, index) in columns"
            :key="index"
            :prop="column"
            :label="getLabel(column)"
            :min-width="getColumnWidth(column)"
            show-overflow-tooltip
        >
          <template slot-scope="scope">
          <span
              :class="{ 'error-field': hasError(scope.row.rowIndex, column) }"
          >
            {{ scope.row[column] }}
          </span>
          </template>
        </el-table-column>
      </el-table>

      <!-- Error Section -->
      <div v-if="mergedErrors && mergedErrors.length > 0" class="mb-3 mt-10">
        <div class="w-100 p-4" style="background-color: #EFD6D699;">
          <div class="d-flex justify-content-between">
            <p style="font-size: 16px">File import có <span>{{errorLines.length}}/{{data.length}}</span> tác vụ lỗi</p>
            <p >Tác vụ lỗi {{currentErrorIndex + 1}}/{{errorLines.length}}</p>

          </div>
          <div
              v-for="(error, index) in errorLines[currentErrorIndex]"
              :key="index"
              class="d-flex align-items-center mb-2"
          >
            <el-tag size="small" type="danger" class="mr-2">
              {{ getLabel(error.field) }}
            </el-tag>
            <span class="text-muted"
            >Dòng {{ error.row }}: <span v-html="error.message"></span></span
            >
          </div>
          <div class="d-flex justify-content-center mt-4">
            <el-pagination
                background
                small
                :page-size="1"
                :current-page="currentErrorIndex + 1"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="errorLines.length"
            >
            </el-pagination>
          </div>
        </div>
        <!--      <el-alert-->
        <!--        title="Có lỗi trong file"-->
        <!--        type="error"-->
        <!--        :closable="false"-->
        <!--        show-icon-->
        <!--      >-->
        <!--        <div class="mt-2">-->
        <!--          <div-->
        <!--            v-for="(error, index) in mergedErrors"-->
        <!--            :key="index"-->
        <!--            class="d-flex align-items-center mb-2"-->
        <!--          >-->
        <!--            <el-tag size="small" type="danger" class="mr-2">-->
        <!--              {{ getLabel(error.field) }}-->
        <!--            </el-tag>-->
        <!--            <span class="text-muted"-->
        <!--              >Dòng {{ error.row }}: {{ error.message }}</span-->
        <!--            >-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </el-alert>-->
      </div>
    </div>
  </div>
</template>

<script>
  import * as yup from "yup"
import _ from 'lodash';
export default {
  name: "PreviewTable",
  props: {
    /**
     * Dữ liệu để hiển thị và validate
     * @type {Array}
     */
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    /**
     * Schema validation rules (Yup schema)
     * @type {Object}
     */
    rules: {
      type: Object,
      required: true,
    },
    /**
     * Lỗi từ bên ngoài (API validate). Sẽ merge với lỗi local.
     */
    externalErrors: {
      type: Array,
      required: false,
      default: () => [],
    },
    /**
     * Mapping tên field/cột để hiển thị tiếng Việt
     * @type {Object}
     */
    labels: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      errors: {}, // Format: { rowIndex: { field: message } }
      validationErrors: [], // Format: [{ row, field, message }]
      mergedErrors: [],
      currentErrorIndex: 0
    };
  },
  computed: {
    /**
     * Dữ liệu đã sắp xếp (bản ghi lỗi lên đầu)
     */
    sortedData() {
      if (this.data.length === 0) return [];

      // Tạo Set các rowIndex có lỗi
      const errorRowIndexes = new Set();
      this.mergedErrors.forEach((error) => {
        errorRowIndexes.add(error.row);
      });

      // Sắp xếp: bản ghi có lỗi lên đầu, sau đó theo thứ tự gốc
      const sorted = [...this.data].sort((a, b) => {
        const aHasError = errorRowIndexes.has(a.rowIndex);
        const bHasError = errorRowIndexes.has(b.rowIndex);

        if (aHasError && !bHasError) return -1; // a lên đầu
        if (!aHasError && bHasError) return 1; // b lên đầu
        return a.rowIndex - b.rowIndex; // cùng trạng thái thì theo thứ tự gốc
      });
      return sorted.map((item, index) => ({
        ...item,
        STT: index + 1,
      }));
    },
    /**
     * Danh sách các cột từ data
     */
    columns() {
      if (this.data.length === 0) return [];
      const keys = Object.keys(this.data[0] || {});
      return ['STT', ...keys];
    },
    errorsOfLines(){
      if (this.mergedErrors.length <1)return null
      return _.groupBy(this.mergedErrors, 'row');
    },
    errorLines(){
      if (!this.errorsOfLines)return []
      return Object.values(this.errorsOfLines);
    }
  },
  watch: {
    /**
     * Khi data hoặc rules thay đổi, chạy validation
     */
    data: {
      handler() {
        this.validateData();
      },
      immediate: true,
    },
    rules: {
      handler() {
        this.validateData();
      },
      immediate: true,
    },
    // Khi externalErrors thay đổi thì merge lại và emit
    externalErrors: {
      handler() {
        this.mergeAndEmit();
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    getColumnWidth(column) {
      const label = this.getLabel(column) || column;

      const maxDataLength = Math.max(
        ...this.data.map((row) =>
          row[column] ? String(row[column]).length : 0
        ),
        label.length
      );

      const baseCharWidth = 10;
      let width = maxDataLength * baseCharWidth;

      if (width < 120) width = 120;
      if (width > 300) width = 300;

      return width;
    },
    async validateData() {
      // guard
      if (!Array.isArray(this.data) || this.data.length === 0) {
        this.errors = {}
        this.validationErrors = []
        this.mergeAndEmit()
        return
      }

      if (!this.rules || typeof this.rules !== "object" || Object.keys(this.rules).length === 0) {
        this.errors = {}
        this.validationErrors = []
        this.mergeAndEmit()
        return
      }

      try {
        const validationErrors = []

        // ✅ Schema cho 1 dòng (row) từ rules map (CheckDuLieuSchema)
        const rowSchema = yup.object().shape(this.rules)

        for (let i = 0; i < this.data.length; i++) {
          const row = this.data[i] || {}
          const rowNum = i + 1

          // ✅ Validate từng field, nhưng truyền full row để when("tac_vu") hoạt động
          for (const field of Object.keys(this.rules)) {
            try {
              await rowSchema.validateAt(field, row, { abortEarly: true })
            } catch (error) {
              validationErrors.push({
                row: rowNum,
                field,
                message: error?.message || "Dữ liệu không hợp lệ",
              })
            }
          }
        }

        this.validationErrors = validationErrors

        // Convert sang format errors object { rowIndex: { field: message } }
        const errorMap = {}
        validationErrors.forEach((e) => {
          if (!errorMap[e.row]) errorMap[e.row] = {}
          errorMap[e.row][e.field] = e.message
        })

        this.errors = errorMap
        this.mergeAndEmit()
      } catch (error) {
        console.error("Lỗi validation:", error)
        this.errors = {}
        this.validationErrors = []
        this.mergeAndEmit()
      }
    },

    // Merge local errors với externalErrors và emit ra ngoài
    mergeAndEmit() {
      const merged = [];
      const seen = new Set();

      const push = (e) => {
        if (!e) return;
        const key = `${e.row}|${e.field}|${e.message}`;
        if (!seen.has(key)) {
          seen.add(key);
          merged.push(e);
        }
      };

      (this.validationErrors || []).forEach(push);
      (this.externalErrors || []).forEach(push);

      // Rebuild error map để highlight đầy đủ
      const errorMap = {};
      merged.forEach((error) => {
        if (!errorMap[error.row]) {
          errorMap[error.row] = {};
        }
        errorMap[error.row][error.field] = error.message;
      });
      this.errors = errorMap;

      this.$emit("validated", {
        errors: merged,
        isValid: merged.length === 0,
      });

      // Lưu lại để hiển thị trong danh sách lỗi
      this.mergedErrors = merged;
    },

    /**
     * Kiểm tra cell có lỗi không
     * @param {Number} rowIndex - Index của dòng
     * @param {String} field - Tên field
     * @returns {Boolean}
     */
    hasError(rowIndex, field) {
      return this.errors[rowIndex] && this.errors[rowIndex][field];
    },

    /**
     * Lấy label của field/cột để hiển thị tiếng Việt
     * @param {String} field - Tên field/cột
     * @returns {String}
     */
    getLabel(field) {
      return this.labels[field] || field;
    },
    handleCurrentChange(e){
      this.currentErrorIndex = e - 1
    }
  },
};
</script>

<style scoped>
.preview-table {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

/* Error field highlighting */
.error-field {
  background-color: #fef0f0 !important;
  border: 1px solid #f56c6c !important;
  border-radius: 4px;
  padding: 2px 4px;
  color: #f56c6c;
  font-weight: bold;
}
</style>
